import Icons from './utils/Icons';
import Swiper from 'swiper/bundle';

class Main {
  constructor() {
    this.init();
  }

  init() {
    Icons.load();
    this.initSwiperPartenaires();
    this.initSwiperPartenairesMobile();
    this.initSwiperEvenements();
    this.initSwiperConferencier();
    this.initMenuToggle();
  }

  initSwiperPartenaires() {
    const target = document.querySelector('.swiper_partenaires');
    if (target) {
      const swiper = new Swiper(target, {
        pagination: {
          el: target.querySelector('.swiper-pagination'),
        },
        slidesPerView: 3,
        spaceBetween: 32,
        loop: true,

        breakpoints: {
          768: {
            slidesPerView: 5,
            spaceBetween: 48,
          },
          1024: {
            slidesPerView: 7,
            spaceBetween: 64,
          },
        },
      });
    }
  }

  initSwiperPartenairesMobile() {
    const target = document.querySelector('.swiper_partenaires--mobile');
    if (target) {
      const swiper = new Swiper(target, {
        pagination: {
          el: target.querySelector('.swiper-pagination'),
        },
        slidesPerView: 2,
        loop: true,
      });
    }
  }

  initSwiperEvenements() {
    const target = document.querySelector('.swiper_evenements');
    if (target) {
      const swiper = new Swiper(target, {
        pagination: {
          el: target.querySelector('.swiper-pagination'),
        },
        loop: true,
      });
    }
  }

  initSwiperConferencier() {
    const target = document.querySelector('.swiper_conferenciers');
    if (target) {
      const swiper = new Swiper(target, {
        pagination: {
          el: target.querySelector('.swiper-pagination'),
        },
        slidesPerView: 1,
        loop: true,

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      });
    }
  }

  initMenuToggle(){
    const buttonOpen = document.querySelector(".js-toggle");
    const buttonClose = document.querySelector(".js-toggle_close")
    buttonOpen.addEventListener("click", this.onOpenNav);
    buttonClose.addEventListener("click", this.onCloseNav);

  }

  onOpenNav(){
    const menuToggle = document.querySelector(".menu-toggle");
    menuToggle.classList.add("nav-is-active");
  }

  onCloseNav(){
    const menuToggle = document.querySelector(".menu-toggle");
    menuToggle.classList.remove("nav-is-active");
  }
}
new Main();
